import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, MapPin, DollarSign, Bed, Home, X } from 'lucide-react';
export function PropertySearch() {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setShowModal(true);
  };
  const handleLeadSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setShowModal(false);
      setIsSubmitted(false);
    }, 3000);
  };
  return <section className="relative -mt-16 z-20 px-6 max-w-6xl mx-auto" data-id="element-398">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.5
    }} className="bg-white/90 backdrop-blur-md shadow-2xl rounded-sm p-6 md:p-8 border border-warmGray-dark" data-id="element-399">
        <div className="text-center mb-6" data-id="element-400">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal" data-id="element-401">
            Find Your <span className="italic text-gold" data-id="element-402">Dream Home</span>
          </h2>
        </div>

        <form onSubmit={handleSearch} className="flex flex-col md:flex-row gap-4" data-id="element-403">
          <div className="flex-1 relative" data-id="element-404">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-405">
              <MapPin className="h-5 w-5 text-gold" data-id="element-406" />
            </div>
            <select className="block w-full pl-10 pr-3 py-4 text-base border-b-2 border-warmGray-dark focus:outline-none focus:border-gold bg-transparent appearance-none text-charcoal cursor-pointer transition-colors" data-id="element-407">
              <option value="" data-id="element-408">Any Community</option>
              <option value="summerlin" data-id="element-409">Summerlin</option>
              <option value="southern-highlands" data-id="element-410">Southern Highlands</option>
              <option value="henderson" data-id="element-411">Henderson</option>
              <option value="macdonald-highlands" data-id="element-412">MacDonald Highlands</option>
              <option value="spring-valley" data-id="element-413">Spring Valley</option>
              <option value="southwest" data-id="element-414">Southwest Las Vegas</option>
              <option value="north-las-vegas" data-id="element-415">North Las Vegas</option>
              <option value="green-valley" data-id="element-416">Green Valley</option>
            </select>
          </div>

          <div className="flex-1 relative" data-id="element-417">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-418">
              <DollarSign className="h-5 w-5 text-gold" data-id="element-419" />
            </div>
            <select className="block w-full pl-10 pr-3 py-4 text-base border-b-2 border-warmGray-dark focus:outline-none focus:border-gold bg-transparent appearance-none text-charcoal cursor-pointer transition-colors" data-id="element-420">
              <option value="" data-id="element-421">Any Price</option>
              <option value="300-500" data-id="element-422">$300K - $500K</option>
              <option value="500-750" data-id="element-423">$500K - $750K</option>
              <option value="750-1000" data-id="element-424">$750K - $1M</option>
              <option value="1000-2000" data-id="element-425">$1M - $2M</option>
              <option value="2000-5000" data-id="element-426">$2M - $5M</option>
              <option value="5000+" data-id="element-427">$5M+</option>
            </select>
          </div>

          <div className="flex-1 relative" data-id="element-428">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-429">
              <Bed className="h-5 w-5 text-gold" data-id="element-430" />
            </div>
            <select className="block w-full pl-10 pr-3 py-4 text-base border-b-2 border-warmGray-dark focus:outline-none focus:border-gold bg-transparent appearance-none text-charcoal cursor-pointer transition-colors" data-id="element-431">
              <option value="" data-id="element-432">Any Beds</option>
              <option value="1" data-id="element-433">1+ Bedrooms</option>
              <option value="2" data-id="element-434">2+ Bedrooms</option>
              <option value="3" data-id="element-435">3+ Bedrooms</option>
              <option value="4" data-id="element-436">4+ Bedrooms</option>
              <option value="5" data-id="element-437">5+ Bedrooms</option>
            </select>
          </div>

          <div className="flex-1 relative" data-id="element-438">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-439">
              <Home className="h-5 w-5 text-gold" data-id="element-440" />
            </div>
            <select className="block w-full pl-10 pr-3 py-4 text-base border-b-2 border-warmGray-dark focus:outline-none focus:border-gold bg-transparent appearance-none text-charcoal cursor-pointer transition-colors" data-id="element-441">
              <option value="" data-id="element-442">Any Type</option>
              <option value="single-family" data-id="element-443">Single Family</option>
              <option value="condo" data-id="element-444">Condo / Townhouse</option>
              <option value="luxury" data-id="element-445">Luxury Estate</option>
              <option value="new" data-id="element-446">New Construction</option>
            </select>
          </div>

          <button type="submit" className="md:w-auto w-full bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300 flex items-center justify-center gap-2 flex-shrink-0" data-id="element-447">
            <Search className="w-4 h-4" data-id="element-448" />
            Search
          </button>
        </form>
      </motion.div>

      {/* Lead Capture Modal */}
      <AnimatePresence data-id="element-449">
        {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-450">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" onClick={() => setShowModal(false)} data-id="element-451" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-white w-full max-w-lg p-8 md:p-10 shadow-2xl" data-id="element-452">
              <button onClick={() => setShowModal(false)} className="absolute top-4 right-4 text-charcoal-light hover:text-gold transition-colors" data-id="element-453">
                <X className="w-6 h-6" data-id="element-454" />
              </button>

              {isSubmitted ? <div className="text-center py-8" data-id="element-455">
                  <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mx-auto mb-6" data-id="element-456">
                    <Search className="w-8 h-8 text-gold" data-id="element-457" />
                  </div>
                  <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-458">
                    Search Initiated
                  </h3>
                  <p className="text-charcoal-light font-light" data-id="element-459">
                    Jenny is reviewing your criteria and will send you
                    personalized listings within 24 hours.
                  </p>
                </div> : <>
                  <div className="text-center mb-8" data-id="element-460">
                    <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-461">
                      Unlock Exclusive Listings
                    </h3>
                    <p className="text-charcoal-light font-light text-sm" data-id="element-462">
                      Enter your details below and Jenny will send you a curated
                      list of properties matching your exact criteria, including
                      off-market opportunities.
                    </p>
                  </div>

                  <form onSubmit={handleLeadSubmit} className="space-y-4" data-id="element-463">
                    <div data-id="element-464">
                      <input type="text" required placeholder="Your Name" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-465" />
                    </div>
                    <div data-id="element-466">
                      <input type="email" required placeholder="Email Address" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-467" />
                    </div>
                    <div data-id="element-468">
                      <input type="tel" required placeholder="Phone Number" className="w-full px-4 py-3 border border-warmGray-dark focus:outline-none focus:border-gold transition-colors bg-warmGray" data-id="element-469" />
                    </div>
                    <button type="submit" className="w-full bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300 mt-4" data-id="element-470">
                      View My Matches
                    </button>
                    <p className="text-xs text-center text-charcoal-light/60 mt-4" data-id="element-471">
                      By submitting, you agree to be contacted by Jenny Gong
                      regarding real estate opportunities.
                    </p>
                  </form>
                </>}
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}